import { useState, useEffect } from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import AssetsSearch from '../../Hubs/asset/components/AssetsSearch';
import { isEmpty } from 'lodash';
import axios from 'axios';
import AssetChip from './AssetChip';
import { DeleteIcon } from '../Icons';

export default function AssetSetReference({
  initialAsset,
  onAssetChange,
  onAssetDelete,
  editable = true,
  hasStatusButton = false,
  canEditStatus = false,
  ...props
}) {
  const [choosenAsset, setChoosenAsset] = useState(null);

  useEffect(() => {
    if (initialAsset) {
      axios
        .get('/asset/getAsset', { params: { id: initialAsset } })
        .then(({ data }) => {
          setChoosenAsset(data);
        })
        .catch((err) => {
          console.error('Error fetching asset:', err);
        });
    } else {
      setChoosenAsset(null);
    }
  }, [initialAsset]);

  function assetDelete() {
    setChoosenAsset(null);
    onAssetDelete(initialAsset);
  }

  function assetChange(data) {
    setChoosenAsset(data);
    onAssetChange(data?._id || null);
  }

  return (
    <Grid container item alignItems={'center'} direction={'column'} wrap="nowrap" {...props}>
      <Grid container item direction={'column'}>
        {editable && isEmpty(choosenAsset) && <AssetsSearch onResult={assetChange} searchInAssetData={true} />}

        {!isEmpty(choosenAsset) && choosenAsset?._id && (
          <Grid item container direction={'row'} sx={{ mt: 1, minWidth: '100%', wrap: 'nowrap' }}>
            <AssetChip
              assetId={choosenAsset._id}
              withoutFields
              hasStatusButton={hasStatusButton}
              canEditStatus={editable}
            />
            {editable && (
              <IconButton onClick={assetDelete} sx={{ ml: 1 }}>
                <DeleteIcon color={'red'} />
              </IconButton>
            )}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
